<template>
    <Layout>
        <b-row>
            <b-col xl="2" sm="3">
                <Menu @back="handleBack"/>
            </b-col>
            <b-col xl="10" sm="9">
                <b-row v-if="selected_applicant == false">
                    <b-col cols="12">
                        <StatusHeader/>
                        <ClientsTable v-if="show_form == false" @selectedRow="selectedRow"/>
                        <FormContainer v-else />
                    </b-col>

                </b-row>
                <b-row v-if="selected_applicant == true">
                    <b-col cols="12" >
                        <ApplicantTabs />
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        
    </Layout>
</template>

<script>



import ApplicantTabs from '@/components/admin/applicants/applicantTabs.vue'
import Layout from "../../layouts/main-stripped";
//eslint-disable-next-line
import PageHeader from "@/components/page-header";
import Menu from '@/components/widgets/green-menu.vue'
import FormContainer from '@/components/client/form-container.vue'
import StatusHeader from '@/components/admin/statusBar.vue'
import {layoutMethods} from '@/state/helpers';
import { ccbAdminState, ccbAdminMethods } from "@/state/helpers"
import ClientsTable from '@/components/admin/applicantsTable.vue'
export default {
    data:() => ({
        show_form: false,
        selected_applicant: false,
    }),
    components:{
        StatusHeader,
        ClientsTable,
        Layout,
        FormContainer,
        ApplicantTabs,
        Menu
    },
    computed:{
        ...ccbAdminState
    },
    methods:{
        ...layoutMethods,
        ...ccbAdminMethods,
        selectedRow(id){
            console.log('Row -> '+ id);
            //if valid row
            this.loadClientData(id)
            .then(()=>{
                this.selected_applicant = true;
            })
            .catch(()=>{
                alert('loading error');
            })
            //this.show_form = true;
            
        },
        handleBack(){
            
        },
        handleBackEvent(){
            this.show_form = false;
            this.selected_applicant = false;
        }
    },
    mounted(){
        this.$eventHub.$on('navigateBack', this.handleBackEvent)
        setTimeout(()=>{
            this.loadAdminUsers();
            this.loadClients();
        }, 500);
        this.updateMenuType({
            type: 'ccb_applicants',
            showMenu: true,
            showRoutes: true,
        })
    },
    beforeDestroy(){
        this.$eventHub.$off('navigateBack');
    }
}
</script>

<style>

</style>